import React from 'react';
import { isMobile } from 'react-device-detect';
import {
  StyledWrapper,
  StyledInnerCircle,
  StyledCircle,
  StyledLabelSvg,
  StyledLabelText,
  StyledReactTooltip,
  StyledHoverPlaceholder,
} from './styled';
import { getMediaColor } from '../../../service/data';
import { formatLocal, useDisplayTimezone } from '../../../service/localTime';

const ratingFromItem = (item) => {
  if (item && typeof item === 'object') {
    const value = item.rating ?? item.media_rating ?? item.value ?? item.score;
    const date =
      item.match_date || item.date || item.matchDate || item.played_at || null;
    return { value: Number(value), date };
  }
  return { value: Number(item), date: null };
};

const DonutChart = ({ arcSize = 1, index, small }) => {
  useDisplayTimezone();
  const { value, date } = ratingFromItem(arcSize);
  const rating = Number.isFinite(value) ? value : 0;
  const circumference = small ? 56 : 113;
  const strokeDasharray = `${circumference} ${circumference}`;
  const size = small ? 22 : 42;
  const center = small ? 11 : 21;

  const percent = rating * 10;
  const offset = circumference - (percent / 100) * circumference;
  const arcColor = getMediaColor(rating);
  const chartId = `${index}${rating}${date || ''}`;
  const when = date ? formatLocal(date, 'D MMM YYYY') : '';
  const tooltip = when || `${index} Match${index > 1 ? 'es' : ''} ago`;
  return (
    <StyledWrapper small={small} data-tip clickable data-for={chartId}>
      <StyledHoverPlaceholder>{rating}</StyledHoverPlaceholder>

      <svg
        className="donut-ring"
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <StyledInnerCircle
            small={small}
            r={small ? '7' : '14'}
            cy={center}
            cx={center}
            strokeDasharray={strokeDasharray}
            dashArray={circumference}
            offset={offset}
          />
          <StyledCircle
            r={small ? '9' : '17'}
            cy={center}
            cx={center}
            strokeWidth={small ? '3' : '6'}
            stroke={arcColor}
            strokeDasharray={strokeDasharray}
            dashArray={circumference}
            offset={offset}
          />
        </g>
      </svg>

      <StyledLabelSvg
        viewBox={`0 0 ${size} ${size}`}
        width={size}
        height={size}
        aria-hidden
      >
        <StyledLabelText $small={small} x={center} y={center}>
          {rating}
        </StyledLabelText>
      </StyledLabelSvg>

      <StyledReactTooltip
        id={chartId}
        type="dark"
        effect="solid"
        place="bottom"
        disable={Boolean(isMobile)}
      >
        {tooltip}
      </StyledReactTooltip>
    </StyledWrapper>
  );
};
export default DonutChart;
